import { Outlet, useLocation } from 'react-router-dom'
import TopNavbar from './TopNavbar'
import BottomNavbar from './BottomNavbar'

const AppLayout = () => {
  const location = useLocation()
  const isProjectView = location.pathname.startsWith('/project/')
  const isProjectDetailPage = location.pathname.startsWith('/projects/') && location.pathname !== '/projects'

  return (
    <div className="min-h-screen bg-neutral-100">
      {/* Top Navigation */}
      <TopNavbar />

      {/* Main Content Area */}
      <main className="min-h-screen pt-16 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Outlet />
        </div>
      </main>

      {/* Bottom Navigation - Hidden on ProjectView and ProjectDetailPage */}
      {!isProjectView && !isProjectDetailPage && <BottomNavbar />}
    </div>
  )
}

export default AppLayout
